import { memo } from "react";
import { Pressable, View } from "react-native";

interface SwitchToggleProps {
  value: boolean;
  onValueChange: (value: boolean) => void;
  disabled?: boolean;
  className?: string;
}

const SwitchToggle = memo(function SwitchToggle({
  value,
  onValueChange,
  disabled = false,
  className = "",
}: SwitchToggleProps) {
  return (
    <Pressable
      onPress={() => onValueChange(!value)}
      className={`w-12 h-6 rounded-full ${
        value ? `bg-[#18181B]` : `bg-[#E5E7EB]`
      } flex items-center justify-center ${disabled ? "opacity-50" : ""} ${className}`}
      disabled={disabled}
      style={{ cursor: disabled && "not-allowed" }}
    >
      <View
        className={`w-5 h-5 rounded-full bg-white shadow-sm transform ${
          value ? "translate-x-3" : "-translate-x-3"
        }`}
      />
    </Pressable>
  );
});

export default SwitchToggle;
